import React, { useEffect, useState } from "react";
import { Grid, Card, Typography, Button ,Dialog, Hidden, CardContent,IconButton} from "@material-ui/core";
import Components from "./e_components";
// import {E_ChargesDatesDropdown,E_PaymentDatesDropdown} from "./e_common/e_dates-dropdown";
import E_StatementOfAccount from "./service/e_statement-of-account";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "react-responsive";
import { adminService } from "../../services/admin.service";
import { useDispatch, useSelector } from "react-redux";
import { store } from "../../helpers/store";
import moment from "moment";
import E_Payment from "./e_payments/e_payments"
import E_Charges from "./e_charges/e_charges"
import billingHistoryService from "./service/e_billing-history-service"
import E_StatementOfAccountCerificate from "./service/e_billing-download";
import GetAppIcon from "@material-ui/icons/GetApp";
import E_Autopay from "./e_autopay/e_autopay";
import Backlink from "../common/e_backLink/e_back_link";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { routePaths } from "../config/route-paths";
import RefreshIcon from '@material-ui/icons/Refresh';
import i18next from "i18next";

const useStyle = makeStyles((theme) => ({
  heading: {
    color: theme.palette.ePrimary?.base,
    fontWeight: "Bold",
  },
  buttonInside:{
    backgroundColor:theme.palette.ePrimary?.base,
      color:theme.palette.eWhite?.base,
      ['@media (max-width:600px)']: {
      marginTop:"4px !important",
      fontSize:"0.8rem"
      },
      borderRadius: "3rem",
      "&:hover": {
        backgroundColor: theme.palette.ePrimary?.hover
    }
     
  },
  card2Height: {
    height: "27rem",
    ['@media (max-width:600px)']: {
      borderRadius:"8px",
      },
    marginTop:"12px",
    borderRadius:"12px",
    border:"1px solid"+ theme.palette.eLight?.base,
    justifyContent: "center"
  },
  tabpadding:{
    paddingRight:"0.1rem",
    ['@media (max-width:600px)']: {
    paddingBottom:"14px !important",
    paddingRight:"0px"
    },
  },
  mainCardContainer: {
    height: "100%"
  },
  cardContentPadding:{
    paddingTop:"0.3rem",
    paddingBottom:"0.3rem !important"
  },
  button: {
    background: "blue"
  },
  autoPayButtonStyling: {
    background: theme.palette.eSecondary?.base,
    color: theme.palette.whiteColor.main,
    textTransform:"uppercase",
    borderRadius: "3rem",
    "&:hover": {
      backgroundColor: theme.palette.eSecondary?.hover
  }
  },
  smallAutoPayButton: {
    background: theme.palette.eSecondary?.base,
    color: theme.palette.whiteColor.main,
    marginTop:"4px",
    borderRadius: "3rem",
    fontSize:"0.8rem",
    textTransform:"uppercase"
  },
  faqcolor:{
    color: theme.palette.ePrimary?.base,
    fontWeight: 'bold',
    '&:hover': {
      color: theme.palette.ePastelColor2?.base
    }
  },
  closeIcon: {
    color: theme.palette.ePrimary?.base,
    position:"absolute",
    top:"10px",
    right:"10px"
  },
  rightIcon: {
    textAlign: "-webkit-right",
    position:"relative"
  },
  contentColor: {
    backgroundColor: theme.palette.eLight?.base,
    color: theme.palette.ePastelColor2?.base,
    paddingLeft: "3%",
  },
  dialogBackground:{
    backgroundColor: theme.palette.eLight?.base,
  },
  dialog:{
   position:"relative",
   zIndex:300 +"!important"
  },
  buttonDiv:{
    display:"flex",
    flexDirection:"row",
    justifyContent:"flex-end",
    gap:"10px",
    alignItems:"center"
  },
  buttonsDiv:{
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    justifyContent:'space-evenly',
    gap:"10px",
    margin:"8px 0px !important"
  },
  ref:{
    fontSize:"1.2rem"
  }
}));
let widgets = [
  {
    widgetName: "E_Charges",
    widgetRank: 1,
    wWidget: 6,
    widgetValue: true
  },
  {
    widgetName: "E_Payment",
    widgetRank: 2,
    wWidget: 6,
    widgetValue: true
  },
  {
    widgetName: "E_Autopay",
    widgetRank: 3,
    wWidget:6,
    widgetValue: true
  },

];

export default function Billing() {
  const smallMobile = useMediaQuery({ query: "(min-width: 280px) and (max-width: 767px)" });
  let currentDate = new Date();
  const TYPE_POSTPAID = 'postpaid';
  const useStyleClasses = useStyle();
  const [orderWidgets, setOrderWidgets] = useState();
  const [subtitle, setSubTitle] = useState("");
  const [pretitle,setPretitle] = useState("")
  const isTabletOrMobile = useMediaQuery({ minWidth: 600 });
  let isPrepaid = useSelector((store)=>store?.meterDetails?.getSaInfo?.isPrepaidSa)
  const primaryIdentifier = useSelector((state) =>state?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER);
  const accountId = store.getState().meterDetails.accountId;
  const saStartDate= useSelector((state) => state?.meterDetails?.getSaInfo?.saStartDate);
  const [dateDropdownCategory, setDateDropdownCategory] = React.useState('0');
  let endDate = moment(currentDate).format("YYYY-MM-DD");
  const [postPaidHistoryData, setPostPaidHistoryData] = useState();
  const [prePaidHistoryData, setPrePaidHistoryData] = useState();
  const [prePaidBillHistoryData, setPrePaidBillHistoryData] = useState();
  const [prePaidPaymentHistoryData, setPrePaidPaymentHistoryData] = useState();
  const [postPaidStartDate, setPostPaidStartDate] = useState(moment(currentDate).subtract(1, "year").format("YYYY-MM-DD"));
  // const [postPaidEndDate, setPostPaidEndDate] = useState(moment(currentDate).format("YYYY-MM-DD"));
  const [prePaidBillStartDate, setPrePaidBillStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [prePaidPaymentStartDate, setPrePaidPaymentStartDate] = useState(moment(currentDate).subtract(1, "year").format("YYYY-MM-DD"));
  const [pretPaidBillEndDate, setPretPaidBillEndDate] = useState(moment(currentDate).format("YYYY-MM-DD"));
  const [pretPaidPaymentEndDate, setPretPaidPaymentEndDate] = useState(moment(currentDate).format("YYYY-MM-DD"));
  const [rend, setRend] = useState(0);
  const dispatch = useDispatch();
  const [load, setLoad] = useState();
  const [error, setError] = useState(0);
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState(moment(currentDate).subtract(1, "year").format("YYYY-MM-DD"));
  const [clickOnAutoPay, setClickOnAutoPay] = useState(false);
  const [isloading,setIsLoading] = useState(false);
  const [isPrepaidBillLoading, setIsPrepaidBillLoading] = useState(false);
  const [isPrepaidPaymentLoading, setIsPrepaidPaymentLoading] = useState(false);
  const [refresh,setRefresh] = useState(false)
  let AUTOPAY_ENABLE = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.AUTO_PAY_ENABLED
  );
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  const {t:autoPay, ready: autopayLabelReady} = useTranslation("label-E_AUTO_PAYMENT");
  let AutopayTab = autopayLabelReady ? autoPay("E_AUTOPAY_TAB_TITLE") : '';
  let isSOADialog = true;
  const handleClose = () => {
    localStorage.removeItem("enabled_state")
    setOpen(false);
  };

  useEffect(()=>{
    let enabled_state_value=localStorage.getItem("enabled_state")
    if(enabled_state_value)
    localStorage.removeItem("enabled_state")
  },[])
  useEffect(() => {
    setLoad(1);
    setPostPaidHistoryData();
    setPrePaidHistoryData();
    if (accountId && postPaidStartDate && endDate && isPrepaid !== 'Y') {
      setIsLoading(true)
      billingHistoryService
        .gettingData(endDate, accountId, startDate,refresh)
        .then((response) => {
          setPostPaidHistoryData(response?.data?.getBillPayHistory?.financialBillHistory?.postpaidHistory);
          setIsLoading(false)
          setRend(0)
          setLoad(0);
          localStorage.removeItem("payment")
          setRefresh(false)
        })
        .catch((err) => {
          setIsLoading(false)
          setLoad(0);
          setError(1);
          localStorage.removeItem("payment")
        });
    }
  }, [accountId, postPaidStartDate, endDate, refresh]);
  useEffect(() => {
    getPrepaidBillHistory(accountId, prePaidBillStartDate, pretPaidBillEndDate, isPrepaid);
  }, [accountId, prePaidBillStartDate, pretPaidBillEndDate, isPrepaid]);
  useEffect(() => {
    getPrepaidPaymentHistory(accountId, prePaidPaymentStartDate, pretPaidPaymentEndDate, isPrepaid);
  }, [accountId, prePaidPaymentStartDate, pretPaidPaymentEndDate, isPrepaid]);
  const getPrepaidBillHistory = (accountId, prePaidBillStartDate, pretPaidBillEndDate, isPrepaid, networkFetch = false) => {
    if(accountId && prePaidBillStartDate && pretPaidBillEndDate && isPrepaid === 'Y') {
      setIsPrepaidBillLoading(true);
      billingHistoryService
        .getPrepaidBillingHistoryDetails(pretPaidBillEndDate, accountId, prePaidBillStartDate, "Bill", networkFetch)
        .then((response) => {
          setPrePaidBillHistoryData(response?.data?.getBillPayHistoryPrepaid?.financialBillHistory?.prepaidHistory);
          setIsPrepaidBillLoading(false)
          setRefresh(false)
        })
        .catch((err) => {
          setIsPrepaidBillLoading(false)
        });
    }
  }
  const getPrepaidPaymentHistory = (accountId, prePaidPaymentStartDate, pretPaidPaymentEndDate, isPrepaid, networkFetch = false) => {
    if(accountId && prePaidPaymentStartDate && pretPaidPaymentEndDate && isPrepaid === 'Y') {
      setIsPrepaidPaymentLoading(true);
      billingHistoryService
        .getPrepaidBillingHistoryDetails(pretPaidPaymentEndDate, accountId, prePaidPaymentStartDate, "Payment", networkFetch)
        .then((response) => {
          setPrePaidPaymentHistoryData(response?.data?.getBillPayHistoryPrepaid?.financialBillHistory?.prepaidHistory);
          setIsPrepaidPaymentLoading(false)
          localStorage.removeItem("payment")
          setRefresh(false)
        })
        .catch((err) => {
          setIsPrepaidPaymentLoading(false)
        });
    }
  }
  if (rend === 0 && (prePaidHistoryData || postPaidHistoryData)) {    
    setRend(1);
  }
  const {t:billsLabel, ready: billsLabelReady} = useTranslation("label-E_BILLS_CHARGES_AND_PAYMENTS");
  let billslabels =billsLabel("E_BILLING_HEADING");

  const {t:paymentLabel, ready: paymentLabelReady} = useTranslation("label-E_BILLS_CHARGES_AND_PAYMENTS");
  let paymentlabels = paymentLabel("E_PREPAID_CHARGES_AND_PAYMENTS_HEADER");
  let language = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  //const statementOfAccount = useSelector((state)=>state?.labels?.data?.getLabels?.BILLING_HISTORY?.BILLING_VIEWSTATMENTOFACCOUNT);
  const {t:statementOfAccount, ready: statementOfAccountReady} = useTranslation("label-BILLING_HISTORY");
  const {t:content, ready: contentReady} = useTranslation("content-E_BILLS_CHARGES_AND_PAYMENTS");
  useEffect(() => {
    widgets.sort((a, b) => {
      return a.widgetRank - b.widgetRank;
    });
    let inOrder = widgets.filter((i) => i.widgetValue === true);
    setOrderWidgets(inOrder);
  }, [widgets]);

  const onClickAutoPay = () => {
    setClickOnAutoPay(!clickOnAutoPay)
  }
  const primaryLanguageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const [allDates,setAllDates] = useState();
  const [twelveMonths,setTwelveMonths] = useState();
  const [sixMonths,setSixMonths] = useState();
  const [currentMonthDates,setCurrentMonthDates] = useState();
  const [threeMonths,setThreeMonths] = useState();
  const [lastMonth,setLastMonth] = useState();
  useEffect(() => {
    if(i18next.language){
    store.getState().snackbar = true;
    billingHistoryService.gettingDropdown("E_PREPAID_CHARGES_PAYMENTS_TIME_PERIOD",i18next.language).then((resp) => {
      setAllDates(resp.data.getDropdownData[0].dropDownValue);
      setTwelveMonths(resp.data.getDropdownData[1].dropDownValue);
      setSixMonths(resp.data.getDropdownData[2].dropDownValue);
      setCurrentMonthDates(resp.data.getDropdownData[3].dropDownValue);
      setLastMonth(resp.data.getDropdownData[4].dropDownValue);
      setThreeMonths(resp.data.getDropdownData[5].dropDownValue);
      store.getState().snackbar = false;
    })
    .catch(err => {
      setAllDates("");
      setTwelveMonths("");
      setSixMonths("");
      setCurrentMonthDates("")
      setLastMonth("")
      setThreeMonths("")
      store.getState().snackbar = false;
    })
  }
  }, [primaryLanguageCode,i18next]);

  useEffect(()=>{
    setOpen(false)
  },[accountId])

  const refrreshHandler=()=>{
    getPrepaidBillHistory(accountId, prePaidBillStartDate, pretPaidBillEndDate, isPrepaid, true);
    getPrepaidPaymentHistory(accountId, prePaidPaymentStartDate, pretPaidPaymentEndDate, isPrepaid, true);
  }

  return (
    <Card 
      className={useStyleClasses.mainCardContainer}
      style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
    >
       <CardContent className={useStyleClasses.cardContentPadding} >
        <Grid container>
          <Grid item xs={12}>
            <Backlink />
          </Grid>
            <Grid item >
            {
              billsLabelReady && paymentLabelReady ?
              <Typography className={useStyleClasses.heading}
              variant="h5">
                {(isPrepaid === "N" ) ?  billslabels : paymentlabels}
              </Typography>
              : <Skeleton />
            }
            </Grid>
            <Grid container direction="row">
              <Grid item sm={12}>
              {
                contentReady?
                <Typography  
                align="left"
                variant="subtitle2" 
                >{(isPrepaid === "N") ? content("E_BILLING_TEXT").answer :
                content("E_PREPAID_CHARGES_PAYMENTS_SUBTITLE").answer}  <Link to={routePaths.SELF_HELP} underline="always" className={useStyleClasses.faqcolor}>
                {billsLabelReady?billsLabel("E_FAQ"):""}
              </Link></Typography>
                : <Skeleton />
              }         
              </Grid>
            </Grid>
        </Grid>
          <Hidden mdUp>
            <div className={useStyleClasses.buttonsDiv}>
                  <Button
                    variant="contained"
                    className={useStyleClasses.buttonInside}
                    onClick={refrreshHandler}
                    endIcon={<RefreshIcon className={useStyleClasses.ref}/>}
                  >
                    Refresh
                  </Button>
                  <Button
                    variant="contained"
                    className={useStyleClasses.buttonInside}
                    onClick={() => {
                      setOpen(true);
                    }}

                    endIcon={<GetAppIcon fontSize="small" />}
                  >
                    {statementOfAccount("BILLING_VIEWSTATMENTOFACCOUNT")}
                    </Button>
              {(!clickOnAutoPay && isPrepaid === "N" && AUTOPAY_ENABLE) && (
                  <Button
                    className={smallMobile ? useStyleClasses.smallAutoPayButton : useStyleClasses.autoPayButtonStyling}
                    variant="contained"
                    onClick={onClickAutoPay}
                  >
                    {AutopayTab}
                  </Button>
              )}
              </div>
          </Hidden>
          <Hidden smDown>
            <div className={useStyleClasses.buttonDiv}>
              {(!clickOnAutoPay && isPrepaid === "N" && AUTOPAY_ENABLE) && (
                  <Button
                    className={smallMobile ? useStyleClasses.smallAutoPayButton : useStyleClasses.autoPayButtonStyling}
                    variant="contained"
                    onClick={onClickAutoPay}
                  >
                    {AutopayTab}
                  </Button>
              )}
                  <Button
                    variant="contained"
                    className={useStyleClasses.buttonInside}
                    onClick={refrreshHandler}
                    endIcon={<RefreshIcon className={useStyleClasses.ref}/>}
                  >
                    {billsLabelReady?billsLabel("E_REFRESH_BTN"):""}
                  </Button>
                  <Button
                    variant="contained"
                    className={useStyleClasses.buttonInside}
                    onClick={() => {
                      setOpen(true);
                    }}

                    endIcon={<GetAppIcon fontSize="small" />}
                  >
                     {statementOfAccount("BILLING_VIEWSTATMENTOFACCOUNT")}
                  </Button>

                 </div>
          </Hidden>
        {orderWidgets ? (
            <Grid container  >
            {isPrepaid === "N" ? (
                <>
                  <Hidden mdDown>
                    <Grid className={useStyleClasses.tabpadding} item xs={12} lg={clickOnAutoPay ? 4 : 6} >
                      <Card className={isTabletOrMobile && useStyleClasses.card2Height}>
                        <E_Charges lastMonth={lastMonth} threeMonths={threeMonths} currentMonthDates = {currentMonthDates} sixMonths={sixMonths} twelveMonths={twelveMonths} allDates={allDates} isloading={isloading} dateDropdownCategory={dateDropdownCategory} billsandPaymentsData={postPaidHistoryData} tabName="bills" />
                      </Card>
                    </Grid>
                    <Grid className={clickOnAutoPay && useStyleClasses.tabpadding} item xs={12} lg={clickOnAutoPay ? 4 : 6} >
                      <Card className={isTabletOrMobile && useStyleClasses.card2Height}>
                        <E_Payment  lastMonth={lastMonth} threeMonths={threeMonths} currentMonthDates = {currentMonthDates} sixMonths={sixMonths} twelveMonths={twelveMonths} allDates={allDates} isloading={isloading} dateDropdownCategory={dateDropdownCategory} billsandPaymentsData={postPaidHistoryData} tabName="payments" />
                      </Card>
                    </Grid>
                    {
                      clickOnAutoPay && (
                        <Grid item xs={12} lg={clickOnAutoPay ? 4 : 6}>
                          <Card className={useStyleClasses.card2Height}>
                            <E_Autopay onClickAutoPay={onClickAutoPay} />
                          </Card>
                        </Grid>
                      )
                    }
                  </Hidden>
                  <Hidden lgUp>
                    {
                        clickOnAutoPay && (
                          <Grid item xs={12} className={useStyleClasses.tabpadding}>
                            <Card className={useStyleClasses.card2Height}>
                              <E_Autopay onClickAutoPay={onClickAutoPay} />
                            </Card>
                          </Grid>
                        )
                      }
                    <Grid className={useStyleClasses.tabpadding} item xs={12}>
                      <Card className={isTabletOrMobile && useStyleClasses.card2Height}>
                        <E_Charges  lastMonth={lastMonth} threeMonths={threeMonths} currentMonthDates = {currentMonthDates} sixMonths={sixMonths} twelveMonths={twelveMonths} allDates={allDates} isloading={isloading} dateDropdownCategory={dateDropdownCategory} billsandPaymentsData={postPaidHistoryData} tabName="bills" />
                      </Card>
                    </Grid>
                    <Grid className={useStyleClasses.tabpadding} item xs={12} >
                      <Card className={isTabletOrMobile && useStyleClasses.card2Height}>
                        <E_Payment  lastMonth={lastMonth} threeMonths={threeMonths} currentMonthDates = {currentMonthDates} sixMonths={sixMonths} twelveMonths={twelveMonths} allDates={allDates} isloading={isloading} dateDropdownCategory={dateDropdownCategory} billsandPaymentsData={postPaidHistoryData} tabName="payments" />
                      </Card>
                    </Grid>
                    
                  </Hidden>
               </>
               ) : (
                <>
                <Grid className={useStyleClasses.tabpadding} item xs={12} lg={6} >
                  <Card className={isTabletOrMobile && useStyleClasses.card2Height}>
                  <E_Charges  lastMonth={lastMonth} threeMonths={threeMonths} currentMonthDates = {currentMonthDates} sixMonths={sixMonths} twelveMonths={twelveMonths} allDates={allDates} isloading={isPrepaidBillLoading} setStartDate={setPrePaidBillStartDate} setEndDate={setPretPaidBillEndDate} dateDropdownCategory={dateDropdownCategory} billsandPaymentsData={prePaidBillHistoryData} tabName="charges"/>
                  </Card>
                </Grid>
                <Grid item xs={12} lg={6} className={useStyleClasses.tabpadding}>
                  <Card className={isTabletOrMobile && useStyleClasses.card2Height}>
                    <E_Payment  lastMonth={lastMonth} threeMonths={threeMonths} currentMonthDates = {currentMonthDates} sixMonths={sixMonths} twelveMonths={twelveMonths} allDates={allDates} isloading={isPrepaidPaymentLoading} setStartDate={setPrePaidPaymentStartDate} setEndDate={setPretPaidPaymentEndDate} dateDropdownCategory={dateDropdownCategory} billsandPaymentsData={prePaidPaymentHistoryData} tabName="payments"/>
                  </Card>
                </Grid>
                {/* <Grid item xs={12} lg={4} className={useStyleClasses.tabpadding}>
                  <Card className={isTabletOrMobile && useStyleClasses.card2Height}>
                    <E_Payment  lastMonth={lastMonth} threeMonths={threeMonths} currentMonthDates = {currentMonthDates} sixMonths={sixMonths} twelveMonths={twelveMonths} allDates={allDates} isloading={isloading} dateDropdownCategory={dateDropdownCategory} billsandPaymentsData={postPaidHistoryData} tabName="payments" type={TYPE_POSTPAID}/>
                  </Card>
                </Grid> */}
               </>
              )}
               <Dialog open={open} onClose={handleClose} disableBackdropClick className={useStyleClasses.dialog}>
               <Grid
               container
               alignItems="center"
               className={useStyleClasses.contentColor}
               justify="space-between"
             >
             <Grid item xs={10}>
             </Grid>
               <Grid item xs={2} className={useStyleClasses.rightIcon}>
                 <IconButton aria-label="close" onClick={handleClose}>
                   <CloseIcon className={useStyleClasses.closeIcon} />
                 </IconButton>
               </Grid>
             </Grid>
             <div className={useStyleClasses.dialogBackground}>
        <E_StatementOfAccountCerificate setOpen={setOpen} isDialog={isSOADialog}/>
        </div>
      </Dialog>
          </Grid>
          ) : (
            <Skeleton />
          )}
          </CardContent> 
    </Card>
  );
}

